import React from "react";
import {ActionRow, ActionRowMoreButton} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useTooltip} from "@components/widgets/tooltip/TooltipProvider";
import {SetURLSearchParams} from "react-router-dom";
import {JobApplicationsFilterStatus} from "@widgets/jobApplications/overview/JobApplications";
import jobApplicationStatusFilter from "@widgets/jobApplications/overview/heading/JobApplicationStatusFilter";

type Props = {
    statusFilter: JobApplicationsFilterStatus;
    setSearchParams: SetURLSearchParams;
};

const JobApplicationsPageHeadingActions = ({statusFilter, setSearchParams}: Props) => {
    const intl = useIntl();
    const {applyTooltip} = useTooltip();

    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            {jobApplicationStatusFilter({statusFilter, setSearchParams, intl, applyTooltip})}
        </ActionRow>
    );
};

export default JobApplicationsPageHeadingActions;